import React, { useState, useEffect } from 'react';
import { Table, Button, Drawer, KeyValuePairs, ColumnLayout, FormField, Input, ExpandableSection, Cards, SegmentedControl, Multiselect, MultiselectProps, Select, SelectProps, Toggle, ToggleProps, Icon, Badge } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import TextFilter from '@cloudscape-design/components/text-filter';
import Pagination from '@cloudscape-design/components/pagination';
import { CustomAppLayout } from '../../layout';
import { useRouter } from '../../router';
import { useStore } from '../../store';
import Box from '@cloudscape-design/components/box';
import CollectionPreferences from '@cloudscape-design/components/collection-preferences';
import ButtonDropdown from '@cloudscape-design/components/button-dropdown';
import { useGlobalState } from '../../../context/GlobalStateContext';
import { formatPhone, storeJWT } from '../../../commons/functions';
import { access } from 'fs';
import { useStoreAdmin } from '../../../context/useStoreAdmin';

const pageSize = 20;

export const SecurityAssignmentPage = () => {
    const storeAdmin = useStoreAdmin();
  const { idPropiedad, setIdPropiedad } = useGlobalState();
  const { JWT, setJWT } = useGlobalState(); 
  const [visibleUnit, setVisibleUnit] = useState(true);
  const [visibleAccess, setVisibleAccess] = useState(true);
  const [visibleUser, setVisibleUser] = useState(true);
  //const [loadingTable, setLoadingTable] = useState(true);

  const [selectedAccesses, setSelectedAccesses] = useState<string[]>([]);

  const {
    actions: { makeHelpPanelHandler },
  } = useStore();
  const { navigate } = useRouter();
                const { setLoading } = useGlobalState();
  const [selectedType, setSelectedType] = useState('');
  const [selectedPolicy, setSelectedPolicy] = useState<SelectProps.Option | null>(null);

  const [policies, setPolicies] = useState<PolicyItem[]>([]);

  const [users, setUsers] = useState<UserItem[]>([]);
  const [accesses, setAccesses] = useState<AccessItem[]>([]);
  const [units, setUnits] = useState<UnitItem[]>([]);

  const [selectedPolicies, setSelectedPolicies] = useState<PolicyItem[]>([]);
  const [policyOptions, setPolicyOptions] = useState<MultiselectProps.Option[]>([]);


  const [filteringTextUnit, setFilteringTextUnit] = useState('');
  const [filteredTextAccess, setFilteredTextAccess] = useState('');
  const [filteringTextUser, setFilteringTextUser] = useState('');

  type AccessItem = {
    idAcceso: number;
    acceso: string;
    sector: string;
    idSecurity: number;
    idSector: number;
  };

  type UnitItem = {
    idUnidad: number;
    unidad: string;
    idSecurity: number;
  };


  type typeItem = {
    name: string;
    id: string;
  }

  type PolicyItem = {
    policy: string;
    idPolicy: number;
  }

  type UserItem = {
    displayName: string;
    nombre: string;
    apellido: string;
    idControl: number;
    idSecurity: number;
  };


  useEffect(() => {

  }, [selectedAccesses]); // The effect runs every time selectedAccesses changes

  const handleRefresh = async () => {
    try {
      
      setLoading(true)
      const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/admin/security/policies/list',
          'JWT': JWT,

        },
        body: JSON.stringify({})
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();
      storeAdmin(data);
      setPolicies(data.policies)

    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }

  };

  useEffect(() => {
    if (policies.length > 0) {
      const policyOptions2: MultiselectProps.Option[] = policies.map(p => ({
        label: p.policy,
        value: p.idPolicy.toString()
      }));
      setPolicyOptions(policyOptions2);
    }
  }, [policies]);

  useEffect(() => {
    handleRefresh();
  }, []);

  // Convert PolicyItem[] → Multiselect format
  const selectedOptions = selectedPolicies.map(p => {
    const match = policyOptions.find(opt => opt.value === p.idPolicy.toString());
    return match || { label: p.policy, value: p.idPolicy.toString() };
  });

  // Convert Multiselect format → PolicyItem[]
  const handleSelect = ({ detail }: any) => {
    const newSelected: PolicyItem[] = detail.selectedOptions.map((opt: any) => ({
      policy: opt.label,
      idPolicy: parseInt(opt.value)
    }));
    setSelectedPolicies(newSelected);
  };

  const handleRefreshAccesses = async () => {
    setVisibleAccess(true)
    try {
      
      setLoading(true)
      const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx?2', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/admin/security/policies/list/accesses',
          'JWT': JWT,

        },
        body: JSON.stringify({
          idPolicy:selectedPolicy?.value,
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();
      setAccesses(data.accesses)

    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }

  };
  const handleRefreshUnits = async () => {
    setVisibleUnit(true)
    try {
      
      setLoading(true)
      const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx?2', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/admin/security/policies/list/units',
          'JWT': JWT,

        },
        body: JSON.stringify({
          idPolicy:selectedPolicy?.value,
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();
      setUnits(data.units)

    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }

  };
  const handleRefreshUsers = async () => {
    setVisibleUser(true)
    try {
      
      setLoading(true)
      const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx?2', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/admin/security/policies/list/users',
          'JWT': JWT,

        },
        body: JSON.stringify({
          idPolicy:selectedPolicy?.value,
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();
      setUsers(data.users)

    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }

  };
  useEffect(() => {
    setVisibleUnit(false)
    setVisibleUser(false)
    setVisibleAccess(false)
    if (selectedPolicy?.value && selectedType && selectedType !== '' && selectedPolicy?.value !== '') {

      if (selectedType === "accesses") {
        console.log("handleRefreshAccesses()")
        handleRefreshAccesses()
      }
      if (selectedType === "units") {
        console.log("handleRefreshUnits()")
        handleRefreshUnits()

      }
      if (selectedType === "users") {
        console.log("handleRefreshUsers()")
        handleRefreshUsers()
      }
    }
  }, [selectedType, selectedPolicy]);


  const filteredUnits = units.filter(unit => {
    const searchWords = filteringTextUnit.toLowerCase().split(/\s+/).filter(Boolean);
    return searchWords.every(word =>
      unit.unidad.toLowerCase().includes(word) ||
      unit.idUnidad.toString().toLowerCase().includes(word)
    );
  });
  const handleChangeUnit = async (item: UnitItem, detail: ToggleProps) => {
    setUnits(prevUnits =>
      prevUnits?.map(unit =>
        unit.idUnidad === item.idUnidad ? { ...unit, idSecurity: detail.checked ? 1 : 0 } : unit
      ) || []
    );
    let body = {
      idPolicy: selectedPolicy?.value,
      type: selectedType,
      id: item.idUnidad,
      assing: detail.checked,
    }

    try {
      setLoading(true)
      const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx?2', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/admin/security/policies/assign',
          'JWT': JWT,

        },
        body: JSON.stringify(body)
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }    
  }

  const filteredUsers = users.filter(user => {
    const searchWords = filteringTextUser.toLowerCase().split(/\s+/).filter(Boolean);
    return searchWords.every(word =>
      user.displayName.toLowerCase().includes(word) ||
      user.idControl.toString().toLowerCase().includes(word)
    );
  });
  const handleChangeUser = async (item: UserItem, detail: ToggleProps) => {
    setUsers(prevUsers =>
      prevUsers?.map(user =>
        user.idControl === item.idControl ? { ...user, idSecurity: detail.checked ? 1 : 0 } : user
      ) || []
    );
    let body = {
      idPolicy: selectedPolicy?.value,
      type: selectedType,
      id: item.idControl,
      assing: detail.checked,
    }

    try {
      setLoading(true)
      const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx?2', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/admin/security/policies/assign',
          'JWT': JWT,

        },
        body: JSON.stringify(body)
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }    
  }


  const filteredAccesses = accesses.filter(access => {
    const searchWords = filteredTextAccess.toLowerCase().split(/\s+/).filter(Boolean);
    return searchWords.every(word =>
      access.acceso.toLowerCase().includes(word) ||
      access.idAcceso.toString().toLowerCase().includes(word)
    );
  });
  const handleChangeAccess = async (item: AccessItem, detail: ToggleProps) => {
    setAccesses(prevAccesses =>
      prevAccesses?.map(access =>
        access.idAcceso === item.idAcceso ? { ...access, idSecurity: detail.checked ? 1 : 0 } : access
      ) || []
    );
    let body = {
      idPolicy: selectedPolicy?.value,
      type: selectedType,
      id: item.idAcceso,
      assing: detail.checked,
    }

    try {
      setLoading(true)
      const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx?2', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/admin/security/policies/assign',
          'JWT': JWT,

        },
        body: JSON.stringify(body)
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }    
    /*
    const success = await handleUpdateUnits(item.idUnidad, detail.checked);
    if (!success) {
      setUnits(prevUnits =>
        prevUnits?.map(unit =>
          unit.idUnidad === item.idUnidad ? { ...unit, isBlockUnit: item.isBlockUnit } : unit
        ) || []
      );
    }
      */
  };
  return (
    <CustomAppLayout
      toolsHide={true}

      contentType="form"
      breadcrumbs={
        <BreadcrumbGroup
          items={[
            { text: 'Inicio', href: '#home' },
            { text: 'Seguridad', href: '#security' },
            { text: 'Asignaciones', href: '#create-transcription-job' },
          ]}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <>
          <SpaceBetween size='xs' direction='vertical'>
            <ColumnLayout columns={2}>
              <Select
                selectedOption={selectedPolicy}
                onChange={({ detail }) =>
                  setSelectedPolicy(detail.selectedOption)
                }
                options={policyOptions}
                placeholder="Seleccione una política"
              />
              <SegmentedControl
                selectedId={selectedType}
                onChange={({ detail }) =>
                  setSelectedType(detail.selectedId)
                }
                label="Tipo de política"
                options={[
                  { text: "Accesos", id: "accesses" },
                  { text: "Unidades", id: "units" },
                  { text: "Usuarios", id: "users" }
                ]}
              />
            </ColumnLayout>

            <Box display={visibleAccess ? 'block' : 'none'}>
              <Table
                stripedRows
                //loading={loadingUnits}
                columnDefinitions={[
                  {
                    id: "acceso",
                    header: "Acceso",
                    cell: (item) => (
                      <span style={{ fontWeight: item.idSecurity > 0 ? "bold" : "normal" }}>
                        {item.sector!=='*' ? <Badge color='blue'>{item.sector}</Badge>:null}{item.sector!=='*' ? " ":""}{item.acceso}
                        
                      </span>
                    ),
                    isRowHeader: true,
                  },
                  {
                    id: "assign",
                    header: (<><Icon name='lock-private'></Icon></>),
                    width: 60,

                    cell: (item) => (
                      <Toggle
                        onChange={({ detail }) => handleChangeAccess(item, detail)}
                        checked={item.idSecurity > 0}
                      />
                    ),
                  },
                ]}
                items={filteredAccesses}
                trackBy="idAcceso"
                empty={
                  <Box margin={{ vertical: "xs" }} textAlign="center" color="inherit">
                    <SpaceBetween size="m">
                      <b>No tiene unidades registradas</b>
                    </SpaceBetween>
                  </Box>
                }
                filter={
                  <TextFilter
                    filteringText={filteredTextAccess}
                    onChange={({ detail }) => {
                      setFilteredTextAccess(detail.filteringText);
                    }}
                  />
                }
              />
            </Box>
            <Box display={visibleUnit ? 'block' : 'none'}>
              <Table

                stripedRows
                //loading={loadingUnits}
                columnDefinitions={[
                  {
                    id: "unidad",
                    header: "Unidad",
                    cell: (item) => (
                      <span style={{ fontWeight: item.idSecurity > 0 ? "bold" : "normal" }}>
                        {item.unidad}
                      </span>
                    ),
                    isRowHeader: true,
                  },
                  {
                    id: "users",
                    header: (<><Icon name='lock-private'></Icon></>),
                    width: 60,

                    cell: (item) => (
                      <Toggle
                        onChange={({ detail }) => handleChangeUnit(item, detail)}
                        checked={item.idSecurity > 0}
                      />
                    ),
                  },
                ]}
                items={filteredUnits}
                trackBy="idUnidad"
                empty={
                  <Box margin={{ vertical: "xs" }} textAlign="center" color="inherit">
                    <SpaceBetween size="m">
                      <b>No tiene unidades registradas</b>
                    </SpaceBetween>
                  </Box>
                }
                filter={
                  <TextFilter
                    filteringText={filteringTextUnit}
                    onChange={({ detail }) => {
                      setFilteringTextUnit(detail.filteringText);
                    }}
                  />
                }
              />
            </Box>
            <Box display={visibleUser ? 'block' : 'none'}>
              <Table

                stripedRows
                //loading={loadingUnits}
                columnDefinitions={[
                  {
                    id: "displayName",
                    header: "Usuario",
                    cell: (item) => (
                      <span style={{ fontWeight: item.idSecurity > 0 ? "bold" : "normal" }}>
                        {item.displayName}
                      </span>
                    ),
                    isRowHeader: true,
                  },
                  {
                    id: "users",
                    header: (<><Icon name='lock-private'></Icon></>),
                    width: 60,

                    cell: (item) => (
                      <Toggle
                        onChange={({ detail }) => handleChangeUser(item, detail)}
                        checked={item.idSecurity > 0}
                      />
                    ),
                  },
                ]}
                items={filteredUsers}
                trackBy="idControl"
                empty={
                  <Box margin={{ vertical: "xs" }} textAlign="center" color="inherit">
                    <SpaceBetween size="m">
                      <b>No tiene unidades registradas</b>
                    </SpaceBetween>
                  </Box>
                }
                filter={
                  <TextFilter
                    filteringText={filteringTextUser}
                    onChange={({ detail }) => {
                      setFilteringTextUser(detail.filteringText);
                    }}
                  />
                }
              />
            </Box>
          </SpaceBetween>

        </>
      }
    />
  );
};
